'use client'

import { ClientLabel } from 'labels/client'
import { useLabels } from 'labels/hooks/useLabels/useLabels'

import styles from './Conditions.module.scss'
import texts from 'fukku/styles/texts.module.scss'

export function Conditions() {
	const { t } = useLabels()
	return (
		<div className={styles.wrapper}>
			<p className={`${styles.text} ${texts.bodyS}`}>
				<ClientLabel
					placeholderValues={{ privacyPolicy: '/privacy-policy' }}
					linkProps={{ className: styles.link }}
				>
					{t('form.privacyRights.privacyAndCookies.legal')}
				</ClientLabel>
			</p>
			<p className={`${styles.text} ${texts.bodyS}`}>
				{t('form.privacyRights.additionalInfo.bodycopy')}
			</p>
		</div>
	)
}
